import * as actionTypes from '../actions/actionTypes';

export default function paperStatementReducer(state = false, action) {
  switch(action.type){
    case actionTypes.SET_ACCOUNT_PAPERSTATEMENT: {
      return action.accountPaperStatement;
    }
    case actionTypes.RESET_ACCOUNT_PAPERSTATEMENT: {
      return false;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/createAcase/reducers/paperStatementReducer.js